
import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Split } from 'lucide-react';

interface ConditionNodeProps {
  data: {
    label: string;
    description?: string;
    config?: {
      condition?: string;
    }
  };
  selected: boolean;
}

export const ConditionNode: React.FC<ConditionNodeProps> = ({ data, selected }) => {
  return (
    <div className={`p-3 rounded-md border-2 ${selected ? 'border-primary' : 'border-border'} bg-card shadow-sm min-w-[180px]`}>
      <div className="flex items-center gap-2 font-medium text-sm mb-1">
        <Split className="w-4 h-4 text-yellow-500" />
        {data.label}
      </div>
      
      {data.description && (
        <p className="text-xs text-muted-foreground mb-2">{data.description}</p>
      )}
      
      <div className="flex justify-between mt-2 text-xs font-medium">
        <div className="text-green-600">Sim</div>
        <div className="text-red-600">Não</div>
      </div>
      
      <Handle
        type="target"
        position={Position.Top}
        id="in"
        className="w-3 h-3 bg-muted-foreground border-2 border-background"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="out-yes"
        className="left-1/4 w-3 h-3 bg-green-500 border-2 border-background"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="out-no"
        className="left-3/4 w-3 h-3 bg-red-500 border-2 border-background"
      />
    </div>
  );
};
